module.exports = __webpack_public_path__ + "static/media/insurance-web.6dc6ca98.png";